import { createSelector } from 'reselect';

export const getAccount = (state) => state.account;

export const getAccountLoaded = createSelector(
  getAccount,
  (account) => account.loaded
);

export const getCaptchaSiteKey = createSelector(
  getAccount,
  (account) => account.captchaSiteKey
);

export const getAccountError = createSelector(
  getAccount,
  (account) => account.error
);

export const getInviteToken = createSelector(
  getAccount,
  (account) => account.inviteToken
);

export const getIsVerified = createSelector(
  getAccount,
  (account) => account.isVerified
);

export const getSecurityQuestions = createSelector(
  getAccount,
  (account) => account.securityQuestions
);

export const getSecurityQuestionDescription = (key) =>
  createSelector(getSecurityQuestions, (securityQuestions) => {
    if (!securityQuestions?.length) {
      return null;
    }
    const selectedQuestion = securityQuestions.find(
      (securityQuestion) => securityQuestion.key === key
    );

    return selectedQuestion.description;
  });

export const getTerms = createSelector(getAccount, (account) => account.terms);
